module.exports = __webpack_public_path__ + "img/32-green.7f208d19.svg";